// extracted by mini-css-extract-plugin
module.exports = {"content":"Statement_content__wDa9K","ef-box":"Statement_ef-box__MSIXI"};